<template>
  <div class="commonLogin">
    <div class="container">
      <left></left>
      <div class="right">
        <p class="titleNav"><span>商家信息</span> &gt; <span>注册信息</span></p>
        <register ref="info" @memberRegister="memberRegister" />
        <button class="btn" @click="register">注册</button>
      </div>
    </div>
  </div>
</template>

<script>
import Left from '../../components/Login/Left'
import Register from '../../components/Login/Register'
import {reqMerchantRegister} from '../../api/index'
export default {
  data () {
    return {

    }
  },
  created() {
  },
  methods: {
    register() {
      this.$refs.info.verify()
    },
    memberRegister (data) {
      const {city, address, businessContacter, businessName, businessType, dailyCount, salesPlatform, avgPrice, idCardImgUuid} = this.$route.params
      const all ={
        ...data,
        city,
        address,
        businessContacter,
        businessName,
        businessType,
        dailyCount,
        salesPlatform,
        avgPrice,
        idCardImgUuid
      }
      reqMerchantRegister(all).then(res => {
        console.log(res)
        if(res.code === 200){
          this.$message({
            message:'账号注册成功',
            type:'success'
          })
          this.$router.replace('/login?type=merchant')
        } else if(res.code === 500) {
          this.$message({
            message: res.data.errMsg,
            type: 'error'
          })
        }

      })
    }
  },
  components: {
    Left,
    Register
  }
}
</script>

<style scoped lang="less" type="text/less">
.commonLogin{
  .container{
    overflow: hidden;
    /*右边*/
    .right{
      float: left;
      margin-top:80px;
      .titleNav{
          font-size: 20px;
          font-weight: 700;
          color:#2FA1DE;
          span{
            font-size: 20px;
            font-weight: 700;
            color:#2FA1DE;
          }
        }
      .btn {
        width: 100%;
        height: 54px;
        margin-top: 40px;
        margin-bottom: 230px;
        background: #2FA1DE;
        color: #fff;
        border-radius: 27px;
        font-size: 18px;
        border: none;
        cursor: pointer;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Login/MerchantRegister.vue